import React, { useEffect, useRef, useState, useCallback } from 'react';
import { GoogleMap, Marker } from '@react-google-maps/api';

const style = { width: '100%', height: 300 };
const fallback = { lat: 40, lng: -98 };

export default function LocationPicker({ lat, lng, onChange }) {
  const mapRef   = useRef(null);
  const holder   = useRef(null);
  const elemRef  = useRef(null);      // 'PENDING' | HTMLElement | null
  const [center, setCenter] = useState(lat && lng ? { lat, lng } : fallback);

  useEffect(() => { if (lat && lng) setCenter({ lat, lng }); }, [lat, lng]);

  const initPAC = useCallback(async () => {
    if (!window.google || !holder.current) return;
    if (elemRef.current === 'PENDING' || elemRef.current) return;   // guard
    elemRef.current = 'PENDING';

    await window.google.maps.importLibrary('places');

    const el = new window.google.maps.places.PlaceAutocompleteElement();
    el.id = 'pac-input';
    el.inputPlaceholder = 'Address, ZIP, or lat,lng';

    el.addEventListener('gmp-select', async ({ placePrediction }) => {
      const place = placePrediction.toPlace();
      await place.fetchFields({ fields: ['location'] });
      const pos = { lat: place.location.lat(), lng: place.location.lng() };
      onChange(pos);
      setCenter(pos);
      mapRef.current?.panTo(pos);
    });

    holder.current.innerHTML = '';      // nuke leftovers
    holder.current.appendChild(el);
    elemRef.current = el;               // done
  }, [onChange]);

  useEffect(() => {
    initPAC();
    return () => {
      if (elemRef.current && elemRef.current !== 'PENDING') elemRef.current.remove();
      elemRef.current = null;
    };
  }, [initPAC]);

  return (
    <div className="space-y-2">
      <div ref={holder} />
      <GoogleMap
        mapContainerStyle={style}
        center={center}
        zoom={lat && lng ? 10 : 4}
        onLoad={m => (mapRef.current = m)}
        onClick={e => {
          const pos = { lat: e.latLng.lat(), lng: e.latLng.lng() };
          onChange(pos);
          setCenter(pos);
        }}
        options={{ streetViewControl: false, mapTypeControl: false }}
      >
        {lat && lng && <Marker position={{ lat, lng }} />}
      </GoogleMap>
    </div>
  );
}
